export default "__VITE_ASSET__BPXDltAp__"